import _BaseAPIService from "../../_BaseAPIService";

const apiService = _BaseAPIService.instance;
const slug = "api";
const MenuImageService = {
  getList: async () => {
    const response = await apiService.get(`/${slug}/menuimages`);
    // const response = await apiService.get(`/${slug}/menuimages`);
    console.log("🚀 ~ getList: ~ response:", response);
    return response.data;
  },
  getTheme: async (orgCode) => {
    const response = await apiService.get(
      `/${slug}/menuimages/for-theme?orgCode=${orgCode}`
    );
    // const response = await apiService.get(`/${slug}/menuimages`);
    console.log("🚀 ~ getList: ~ response:", response);
    return response.data;
  },
  create: async (formData) => {
    const response = await apiService.post(`/${slug}/menuimages`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  },

  detail: async (id) => {
    const response = await apiService.get(`/${slug}/menuimages/${id}`);
    return response.data;
  },
  delete: async (id) => {
    const response = await apiService.delete(`/${slug}/menuimages/${id}`);
    return response.data;
  },
  update: async (id, formData) => {
    try {
      const response = await apiService.put(
        `/${slug}/menuimages/${id}`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
};

export default MenuImageService;
